import React from 'react'
import * as Sentry from '@sentry/react'

import PopUp from './components/partials/Notifications/PopUp'

class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      error: null,
    }
  }

  static getDerivedStateFromError (error) {
    // Update state so the next render will show the fallback UI.
    return { error }
  }

  componentDidCatch = (error, info) => {
    const ERROR_STYLE = 'color: white; background: red; font-weight: bold'
    console.log(`%c${error}\ninfo: ${info.componentStack}`, ERROR_STYLE)

    // Send error to Sentry
    Sentry.captureException(error, {
      contexts: {
        react: {
          componentStack: info.componentStack
        }
      }
    })
  }

  render () {
    if (this.state.error) {
      return (
        <PopUp
          text='An error in the application has occurred. Please click the link below to go back to the home page.'
          visible
          textButton='Home'
          functionButton={() => {
            window.location.href = '/'
          }}
        />
      )
    } else {
      return this.props.children
    }
  }
}

export default ErrorBoundary
